export type StandardModelOption = { label: string; value: string };

const touchPanels: StandardModelOption[] = ['TNET', 'TMESH'].flatMap((protocol) =>
  Array.from({ length: 9 }, (_, index) => {
    const keys = index + 1;
    return { label: `Glass touch panel — ${keys} key ${protocol}`, value: `TGS10${keys}-${protocol}` };
  })
);

export const standardModelOptions: StandardModelOption[] = [
  ...touchPanels,
  ...['04M', '06M', '08M'].flatMap((size) =>
    ['TNET', 'TMESH'].map((protocol) => ({ label: `TGS custom — ${size} ${protocol}`, value: `TGS-CUSTOM-${size}-${protocol}` }))
  ),
  { label: 'DIN master — TNET', value: 'TDIN-MASTER-01-TNET' },
  { label: 'Power supply — 12V', value: 'TPSU-12V' },
  { label: 'Power supply — 16V DALI', value: 'TPSU-16V-DALI' },
  { label: 'DIN DALI', value: 'TDIN-DALI-01' },
  { label: 'DALI repeater', value: 'TDALI-RPT-01' },
  ...['TNET', 'TMESH'].flatMap((protocol) => [
    { label: `DIN curtain — 4 channel ${protocol}`, value: `TDIN-CUR-04-${protocol}` },
    { label: `DIN dimmer 0–10V — 04 ${protocol}`, value: `TDIN-DIM-010V-04-${protocol}` },
    { label: `DIN phase-cut dimmer — 04 ${protocol}`, value: `TDIN-DIM-PC-04-${protocol}` },
    { label: `DIN RCU custom — ${protocol}`, value: `TDIN-RCU-CUSTOM-${protocol}` }
  ]),
  { label: 'DIN phase-cut booster', value: 'TDIN-BOOST-PC' },
  { label: 'DIN SSR — 20A', value: 'TDIN-SSR-20A' },
  { label: 'DIN SSR — 30A', value: 'TDIN-SSR-30A' },
  { label: 'Relay — 30A 04W', value: 'TRLY-30A-04W' },
  { label: 'Relay — 30A 05W', value: 'TRLY-30A-05W' },
  ...Array.from({ length: 32 }, (_, index) => {
    const channel = String(index + 1).padStart(2, '0');
    return { label: `RCU channel — ${channel} TNET`, value: `TRCU-${channel}-TNET` };
  }),
  { label: 'Thermostat — 24V TMESH', value: 'TTH-24V-TMESH' },
  { label: 'Thermostat — 0–10V TMESH', value: 'TTH-010V-TMESH' },
  { label: 'Edge server', value: 'TES-01' },
  { label: 'Human presence sensor — TNET', value: 'THPS-01-TNET' },
  { label: 'Door contact — TNET', value: 'TDC-01-TNET' },
  { label: 'Occupancy interface actuator', value: 'TOCC-01' },
  { label: 'DALI surge protector', value: 'TSPD-DALI-01' },
  { label: 'LAN interface', value: 'TINT-LAN-01' },
  { label: 'TCP display — 02M TNET', value: 'TCP-DISPLAY-02M-TNET' }
];

const modelNumberPattern = /^[A-Z0-9]+(?:-[A-Z0-9]+)+$/;

export function normalizeModelNumber(value: string): string {
  return value.trim().toUpperCase();
}

export function isTemporaryModelNumber(value: string): boolean {
  const normalized = normalizeModelNumber(value);
  return normalized === 'TEMP' || normalized.startsWith('TEMP-');
}

export function isValidModelNumber(value: string): boolean {
  const normalized = normalizeModelNumber(value);
  return !isTemporaryModelNumber(normalized) && modelNumberPattern.test(normalized);
}
